<app-menubar></app-menubar>
<router-outlet></router-outlet>
<app-sidebar></app-sidebar>